/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  main.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:23
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import FastClick from 'fastclick';

import '@/style/common.less';
import '@/core/lazy_use';
import './permission'; // permission control
import '@/components/ConfirmDialog/index';
import { listenKeyBord } from '@/utils/listenKeyBord';
import '@/components/ResultPopup/index';
import '@/components/shopCarAnimation/index';

import '@/core/global';
import defaultSettings from '@/config/defaultSettings';
import VueWechatTitle from 'vue-wechat-title';
import { goHomeBack } from '@/utils/goHomeBack';
// 引入WebViewJavascriptBridge
import Bridge from '@/utils/bridge';
import { Log } from '@/utils/log';

Vue.prototype.$bridge = Bridge;
Vue.prototype.$eventBus = new Vue();
Vue.prototype.$defaultSettings = defaultSettings;
Vue.prototype.$goHomeBack = goHomeBack;

Vue.prototype.$log = new Log({
  file: 'main.ts',
  name: '初始化',
  type: '页面进入',
});

// ios11及以上已经解决了click点击延迟300ms的问题，若依然引入fastClick，会出现click事件需点击两次才生效的问题
let str = navigator.userAgent.toLowerCase();
let ver = str.match(/cpu iphone os (.*?) like mac os/);
// platform '1'为安卓系统 '2'为ios系统
if (!ver) {
  // 非IOS系统
  FastClick.attach(document.body); // 引入fastclick文件
  window.platform = '1';
} else {
  window.platform = '2';
  console.log('你当前的Ios系统版本为：' + ver[1].replace(/_/g, '.'));
  if (parseInt(ver[1]) < 11) {
    // 若ios版本小於11，引入fastclick文件，否則不引入
    FastClick.attach(document.body);
  }
}

Vue.use(VueWechatTitle);

// 注册原生调用H5的方法
import '@/core/registerHandler';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    // 事件委托，为输入框绑定focus和blur事件处理软键盘弹起和收起的问题
    document.addEventListener('click', (e) => {
      // @ts-ignore
      if (e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA') {
        console.log(1);
        // __isAddEvent自定义属性，用于判断是否已绑定事件
        // @ts-ignore
        if (e.target.__isAddEvent !== true) {
          listenKeyBord(e.target);
          /* ios首次获取焦点先执行一次 */
          if (window.platform === '2') {
            const version = navigator.appVersion.match(
              /OS (\d+)_(\d+)_?(\d+)?/
            );
            if (parseInt(version[1]) <= 12) {
              setTimeout(() => {
                // document.body.scrollTop = document.body.scrollHeight
                // 经验证此参数不能写false，否则ios不生效
                (e.target as any).scrollIntoView(true);
              }, 300);
            }
          }
        }
        // @ts-ignore
        e.target.__isAddEvent = true;
      }
    });
  },
}).$mount('#app');
